


































































import { Component, Vue } from 'vue-property-decorator';
import { DxScrollView } from "devextreme-vue";
import DxSelectBox from "devextreme-vue/select-box";
import AccessGrid from '@/views/settings/components/access_table.vue'
import DButton from '@/components/DButton/button.vue';
import DTagbox from "@/components/DTagbox/tagbox.vue";
import {confirm} from 'devextreme/ui/dialog';
import AnimatePopup from '@/components/AnimatePopup/animate-popup.vue';

import UserManagerService, { User } from '@/services/data/user_manager';
import UserRoleManagerService, { UserRole } from '@/services/data/role_manager';
import AuthService from '@/services/auth_service';
import NotifyService from '@/services/notify_service'
import UserAccessService from '@/services/user_access_service';
import PopupCopyAccessRights from './popup_copy_access_rights.vue'
import PopupDistributeAccessRights from './popup_distribute_access_rights.vue'
import { EcoObjectType } from '@/services/models-service';
import EcoObjectsService from '@/services/eco-objects-service';
import {DxLoadPanel} from "devextreme-vue/load-panel";
import UserService from "@/services/data/user_manager";

export class UserAccessAggListSchema {
  request_uuid: string | null = null;
  data: any = {};
}

@Component({
  name: 'UserAccess',
  components: {
    DxLoadPanel,
    DxScrollView,
    DxSelectBox,
    AccessGrid,
    DButton,
    PopupCopyAccessRights,
    PopupDistributeAccessRights,
    DTagbox,
    AnimatePopup
  }
})
export default class  extends Vue {

  public service = UserAccessService;

  public currentUserId: string | null = null;

  public user_ds: User[] = [];
  public roles_ds: UserRole[] = [];
  public isRoleMode: boolean = false;

  public popupAccessRights = {
    visible: false
  }

  public popupDistributeAccess = {
    visible: false
  }

  public userAccessDS: any = {};
  public backendList: UserAccessAggListSchema;
  public loading: boolean = false;

  public isSave: boolean = false;
  public get animatePopupOptions() {
    return {
      visible: this.isSave,
      text: 'Сохранение настроек доступа...'
    }
  }

  public filialWithUsers: any[] = [];
  public allUsers: any[] = [];

  async created() {
    const user_id = AuthService.getUserIdFromToken();
    const resp = await UserManagerService.userCrud.get();
    if(resp) {
      this.user_ds = resp.data;
    }
    const roles_resp = await UserRoleManagerService.roleCrud.get();
    if(roles_resp) {
      this.roles_ds = roles_resp.data;
    }
    try {
      const response = await EcoObjectsService.get_filials_w_users();
      if (response.data) {
        this.filialWithUsers = response.data;
      } else {
        this.filialWithUsers = [];
      }
    } catch (e) {
      this.filialWithUsers = [];
      console.error("Ошибка загрузки филиалов:", e);
    }
    try {
      const response = await UserService.get();
      if (response.data) {
        this.allUsers = response.data;
      } else {
        this.allUsers = [];
      }
    } catch (e) {
      this.allUsers = [];
      console.error("Ошибка загрузки пользователей:", e);
    }
  }

  mounted() {
    // Если был выбран пользователь из другой вкладки — применить фильтр
    if ((this as any).$root && (this as any).$root._userAccessSelectId) {
      this.currentUserId = (this as any).$root._userAccessSelectId;
      this.isRoleMode = false;
      this.getLoad();
      (this as any).$root._userAccessSelectId = null;
    } else if ((this as any).$root && (this as any).$root._userAccessSelectRoleId) {
      this.currentUserId = (this as any).$root._userAccessSelectRoleId;
      this.isRoleMode = true;
      this.getLoad();
      (this as any).$root._userAccessSelectRoleId = null;
    }
  }

  getLoad() {
    this.resetChanges();
    this.userAccessDS = {};
    this.load();
  }

  openPopup() {
    this.popupAccessRights.visible = true;
  }

  openPopupDistributeAccess() {
    this.popupDistributeAccess.visible = true;
  }

  async onSaving(e: any) {

    if (Object.keys(this.service.changes)?.length) {

      try {
        this.isSave = true;
        const payload = {
          request_uuid: this.backendList.request_uuid,
          data: this.service.changes
        }

        const resp: any = await this.service.save(this.currentUserId, payload);
        if (resp) {
          NotifyService.success('Настройки доступа сохранены')
        } else {
          throw new Error('')
        }
        this.isSave = false;
        this.resetChanges();

        this.service.loadPermissions();

      } catch (e) {
        NotifyService.error(`Ошибка сохранения настроек доступа: ${e}`);
        this.isSave = false;

      }
    }
  }

  filterChanging(e: any) {
    if (this.service.changed) {
      confirm(`Текущие изменения будут потеряны. Выполнить сброс изменений?`, 'Сброс изменений')
        .then(async (answer: boolean) => {
          if (!answer) {
            e.component.close();
          } else {
            this.resetChanges()
            this.userAccessDS = {};
            this.currentUserId = null;
          }
        });
    }
  }

  resetChanges() {
    this.service.changed = false;
    this.service.changes = {};
    const grid = (this.$refs.access_grid as any)
    grid.group_selected = {};
  }

  public async load() {

    if(this.currentUserId)  {
      try {
        this.loading = true;
        const resp: any = await this.service.getUserAccess(this.currentUserId);

        if (resp) {
          this.backendList = resp;
          this.userAccessDS = this.backendList.data;
        }
      } catch (e) {
        console.error(e);
      }
      this.service.changed = false;
      this.loading = false;
    }
  }

}
